export const exceptionError = 'Aggregator/Payer combination not found';

export const exceptionListHeaders = [
  { header: 'exceptionCode', label: 'EXCEPTION CODE' },
  { header: 'exceptionCodeAggregator', label: 'AGGREGATOR CODE' },
  { header: 'description', label: 'DESCRIPTION' },
];
